<template>
    <el-dialog  title="新建简历" :visible.sync="showDialog" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="ruleForm" :rules="rules" :model="ruleForm" class="form-beauty" label-width="100px">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="姓名" prop="name">
                        <el-input size="medium" v-model.trim="ruleForm.name" :maxlength="50"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="性别" prop="gender">
                        <el-radio-group v-model="ruleForm.gender">
                            <el-radio v-for="(item, index) in selectMap.WB_GENDER" :key="item.value"
                                      :label="item.value">{{ item.text }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="手机号" prop="mobilePhone">
                        <el-input size="medium" v-model.trim="ruleForm.mobilePhone" :maxlength="50"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="邮箱" prop="email">
                        <el-input size="medium" v-model.trim="ruleForm.email" :maxlength="50"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="最高学历" prop="maxDegree">
                        <el-select size="medium" v-model="ruleForm.maxDegree" placeholder="请选择">
                            <el-option v-for="(item, index) in selectMap.WB_EDU_DEGREE"
                                       :key="item.value"
                                       :label="item.text"
                                       :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="应聘城市:" prop="expectCityId">
                        <el-select size="medium" v-model="ruleForm.expectCityId" placeholder="请选择">
                            <el-option
                                    v-for="(item, index) in selectMap.WB_POSITION_CITY"
                                    :label="item.text"
                                    :key="index"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="最高学校" prop="maxSchool">
                        <el-autocomplete v-model.trim="ruleForm.maxSchool"
                                         size="medium"
                                         style="display: block;"
                                         :fetch-suggestions="remoteMethod"
                                         :maxlength="50"></el-autocomplete>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="专业" prop="maxMajor">
                        <el-input size="medium" v-model.trim="ruleForm.maxMajor" :maxlength="50"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-form-item label="就读时间:" prop="attendTimes" class="width-longer" style="display:inline-block">
                    <el-date-picker type="month" placeholder="开始时间"
                                    size="medium"
                                    ref="startDate"
                                    v-model="ruleForm.beginTime" @change="startDateChange"
                                    :picker-options="startDateOption"></el-date-picker>
                    至
                    <el-date-picker type="month" placeholder="结束时间"
                                    size="medium"
                                    ref="endDate"
                                    v-model="ruleForm.endTime" @change="endDateChange"
                                    :picker-options="endDateOption"></el-date-picker>
                </el-form-item>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="简历来源" prop="resumeSource">
                        <el-select size="medium"  v-model="ruleForm.resumeSource" placeholder="请选择">
                            <el-option v-for="(item, index) in selectMap.WB_RESUME_SOURCE"
                                       :key="item.value"
                                       :label="item.text"
                                       :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="接受调剂:" prop="acceptRegulate">
                        <el-radio-group v-model="ruleForm.acceptRegulate">
                            <el-radio v-for="(item, index) in selectMap.WB_ACCEPT_REGULATE" :key="item.value"
                                      :label="item.value">
                                {{ item.text }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="应聘职位" prop="positionId">
                <el-select v-model="ruleForm.positionId"
                            size="medium"
                            filterable
                            remote
                            placeholder="请输入关键词"
                            :clearable="true"
                            :remote-method="positionIdRemoteMethod">
                    <el-option v-for="(item, index) in positionList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value"></el-option>
                </el-select>
                <!-- <el-select v-model="ruleForm.positionId" placeholder="请选择">
                    <el-option v-for="(item, index) in positionList"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value"></el-option>
                </el-select> -->
            </el-form-item>
            <el-form-item label="游戏经验" prop="gameExperience">
                <el-input v-model="ruleForm.gameExperience" type="textarea" :autosize="{ minRows: 3, maxRows: 6}"
                          resize="none" :maxlength="1000"></el-input>
            </el-form-item>
            <el-form-item label="当前所在地" prop="residence">
                <el-input size="medium" v-model="ruleForm.residence" :maxlength="50"></el-input>
            </el-form-item>
            <attach-view ref="attach" :data="[]" rid="" :init="cacheData"
                         :action="`${$axios.defaults.baseURL}/resumeAttach/resumefileInsertNew.api`"></attach-view>
        </el-form>
        <div slot="footer">
            <el-button @click="submitForm('ruleForm', true)">完成</el-button>
            <el-button @click="submitForm('ruleForm', false)" type="primary">保存并添加下一位</el-button>
        </div>
    </el-dialog>
</template>
<script type="text/javascript">
    import selectMapMixin from 'mixins/selectMapMixin'
    import formCommonMixin from 'mixins/formCommonMixin'
    import AttachView from '../resumeDetail/items/attach.vue'
    import fetchPositionListMixin from './fetchPositionListMixin'
    import pattern from 'modules/pattern'
    import rules from 'modules/rules'
    import dateOptionMixin from 'mixins/dateOptionMixin'

    export default {
        mixins: [selectMapMixin, formCommonMixin, fetchPositionListMixin, dateOptionMixin, ],
        components: {
            AttachView
        },
        data () {
            const validatorattendTimes = (rule, value, callback) => {
                if (!this.ruleForm.beginTime || !this.ruleForm.endTime) {
                    return callback(new Error('请选择'))
                }
                callback()
            }
            rules.attendTimes = {required: true, validator: validatorattendTimes, message: '请选择', trigger: 'change'}
            return {
                urls: {
                    add: '/resume/insert.api'
                },
                showDialog: false,
                cacheData: [],
                ruleForm: {
                    name: '',
                    gender: '',
                    email: '',
                    mobilePhone: '',
                    maxDegree: '',
                    acceptRegulate: '',
                    maxMajor: '',
                    maxSchool: '',
                    expectCityId: '',
                    positionId: '',
                    beginTime: '',
                    endTime: '',
                    resumeSource: '',
                    gameExperience: '',
                    residence: ''
                },
                rules: rules
            }
        },
        methods: {
            show () {
                this.showDialog = true
                // 及时更新职位列表数据
                this.fetchPositionList()
            },
            saveForm (boolean) {
                let attachs
                // 附件信息
                this.$refs.attach.saveData((data) => {
                    let attachArr = data.map((item, index) => {
                        return {
                            resumeId: item.resumeId,
                            fileId: item.fileId,
                            md5: item.md5
                        }
                    })
                    attachs = JSON.stringify(attachArr)
                })
                this.$axios.post(this.urls.add, Object.assign({}, this.ruleForm, {
                    attachs: attachs
                }), {'X-showMessage': true}).then(res => {
                    this.resetForm('ruleForm')
                    this.cacheData = []
                    if (boolean === true) {
                        this.showDialog = false
                    }
                    this.$emit('reload')
                }).catch(() => {
                })
            },
            positionIdRemoteMethod(query) {
                if (query !== '') {
                    this.$axios.get('/position/searchByName.api', {
                        params: {searchWord: query}
                    }).then(res => {
                        this.positionList = res.result.list
                    })
                } else {
                    this.positionList = this.allPositionList
                }
            },
            remoteMethod (query, cb) {
                let params = {
                    'X-loadingOff': true
                }
                params.queryKey = query
                if (query !== '') {
                    this.$axios.get('/school/search.api', {
                        params: params
                    }).then((res) => {
                        cb(res.result.list.map(item => {
                            return {
                                value: item.name
                            }
                        }))
                    })
                } else {
                    let arr = []
                    cb(arr)
                }
            }
        }
    }
</script>
<style type="text/css" lang="scss">

</style>


// WEBPACK FOOTER //
// addResumeDialog.vue?5ea06c23